import { Organization } from 'generated-graphql/types';
import { atom } from 'recoil';
import { localStorageEffect } from 'services/storage/localStorage';
import { OrganizationConfig } from './type';

export enum OrganizationStateKey {
  OrganizationState = 'OrganizationState',
  OrganizationConfigState = 'OrganizationConfigState'
}

// Update the atom to use the effect
export const organizationAtom = atom<Organization | null>({
  key: OrganizationStateKey.OrganizationState,
  default: null,
  effects: [
    localStorageEffect(OrganizationStateKey.OrganizationState),
    ({ setSelf }) => {
      const handleStorage = (event: StorageEvent) => {
        if (event.key === OrganizationStateKey.OrganizationState) {
          const parsed = event.newValue ? JSON.parse(event.newValue) : null;
          // Ignore null: a sign-out in another tab writes null, and adopting
          // it here strands this tab on the route loading gate — nothing
          // re-selects an organization after mount. Each tab clears its own
          // state through its own auth flow.
          if (parsed) {
            setSelf(parsed);
          }
        }
      };
      window.addEventListener('storage', handleStorage);
      return () => {
        window.removeEventListener('storage', handleStorage);
      };
    }
  ]
});

export const organizationConfigAtom = atom<OrganizationConfig | null>({
  key: OrganizationStateKey.OrganizationConfigState,
  default: null
});

export const organizationLocalStorageItem = () => {
  const organizationString = localStorage.getItem(
    OrganizationStateKey.OrganizationState
  );
  return organizationString
    ? (JSON.parse(organizationString) as Organization)
    : null;
};
